module.exports = __webpack_public_path__ + "resources/img/img_edb_2_m_jp.8e4a661f6eaed318336e876332b580cd.png";